export const Config = {
    api: process.env.REACT_APP_API_HOST || '', //"https://public.fuzzystacoshop.com"
}